export default __webpack_public_path__ + "static/media/retreat-img2.7188bcf5.png";